import React from 'react'

interface DrillDownSectionProps {
  title: string
  subtitle?: string
  children: React.ReactNode
}

export function DrillDownSection({ title, subtitle, children }: DrillDownSectionProps) {
  return (
    <div className="bg-white border border-[#E2E4ED] rounded-xl p-5 mb-4">
      <div className="flex items-baseline gap-2 mb-3">
        <h3 className="text-sm font-semibold text-[#1B2559]">{title}</h3>
        {subtitle && <span className="text-xs text-[#8B8FA7]">{subtitle}</span>}
      </div>
      <div>{children}</div>
    </div>
  )
}
